import {Injectable} from '@angular/core';
import {filter, Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClickListenerService {
  clickedElement$ = new Subject<HTMLElement>();

  clickedOutsideElement$(element: HTMLElement): Observable<HTMLElement> {
    return this.clickedElement$.pipe(
      filter(clickedElement => clickedElement !== element && !element.contains(clickedElement)),
    );
  }
}
